import React from 'react';

interface EmailVerifyProps {
  emailStatus: "idle" | "loading" | "success" | "error";
}

const EmailVerify: React.FC<EmailVerifyProps> = ({ emailStatus }) => {
  if (emailStatus === "idle") return null; // nothing to show

  return (
    <div className="single-section about-area silver-bg" id="after-registration">
      <div className="container">
        <div className="row">
          <div className="verify-email-wrapper">
            <div className="verify-email-container">
              
              {emailStatus === "loading" && (
                <p>Validating your information...</p>
              )}

              {emailStatus === "success" && (
                <div className="success-text">
                  <h2>Email Verified Successfully</h2>
                  <p>Thank you! Your email has been verified.</p>
                  <a href="/login" className="btn-primary">Go to Login</a>
                </div>
              )}

              {emailStatus === "error" && (
                <div className="error-text">
                  <h2>Verification Failed</h2>
                  <p>Your token is invalid or expired.</p>
                </div>
              )}
            
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerify;
